import React from 'react';
import { motion } from 'framer-motion';
import './contact.css';

export default function Contact() {
  return (
    <motion.div
      className="main-div"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.6, ease: [0.23, 1, 0.32, 1] }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.7 }}
      >
        <h1>My professional contact:</h1>
        <motion.h2
          whileHover={{ color: 'rgba(92, 225, 230, 1)', scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          <motion.a
            href="mailto:jrixweb@gmail.com"
            whileHover={{ textShadow: '0 0 20px rgba(92, 225, 230, 0.5)' }}
          >
            jrixweb@gmail.com
          </motion.a>
        </motion.h2>
      </motion.div>
    </motion.div>
  );
}
